import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

import { LanguageKeys } from 'types'

// EN import
import branchEn from 'translations/en/branch.json'
import commonEn from 'translations/en/common.json'
import companyEn from 'translations/en/company.json'
import errorEn from 'translations/en/error.json'
import layoutEn from 'translations/en/layout.json'
import loginEn from 'translations/en/login.json'
import productEn from 'translations/en/product.json'
import productCategoryEn from 'translations/en/productCategory.json'
import profileEn from 'translations/en/profile.json'
import skuEn from 'translations/en/sku.json'
import staffEn from 'translations/en/staff.json'
import ticketEn from 'translations/en/ticket.json'
import pdpaEn from 'translations/en/pdpa.json'
import onboardingEn from 'translations/en/onboarding.json'

// TH import
import branchTh from 'translations/th/branch.json'
import commonTh from 'translations/th/common.json'
import companyTh from 'translations/th/company.json'
import errorTh from 'translations/th/error.json'
import layoutTh from 'translations/th/layout.json'
import loginTh from 'translations/th/login.json'
import productTh from 'translations/th/product.json'
import productCategoryTh from 'translations/th/productCategory.json'
import profileTh from 'translations/th/profile.json'
import skuTh from 'translations/th/sku.json'
import staffTh from 'translations/th/staff.json'
import ticketTh from 'translations/th/ticket.json'
import pdpaTh from 'translations/th/pdpa.json'
import onboardingTh from 'translations/th/onboarding.json'

export const defaultNS = 'common'
export const resources = {
  en: {
    branch: branchEn,
    common: commonEn,
    company: companyEn,
    error: errorEn,
    layout: layoutEn,
    login: loginEn,
    product: productEn,
    productCategory: productCategoryEn,
    profile: profileEn,
    sku: skuEn,
    staff: staffEn,
    ticket: ticketEn,
    pdpa: pdpaEn,
    onboarding: onboardingEn,
  },
  th: {
    branch: branchTh,
    common: commonTh,
    company: companyTh,
    error: errorTh,
    layout: layoutTh,
    login: loginTh,
    product: productTh,
    productCategory: productCategoryTh,
    profile: profileTh,
    sku: skuTh,
    staff: staffTh,
    ticket: ticketTh,
    pdpa: pdpaTh,
    onboarding: onboardingTh,
  },
} as const

i18next.use(initReactI18next).init({
  fallbackLng: LanguageKeys.TH,
  defaultNS,
  resources,
  // debug: process.env.NODE_ENV === 'development',
  parseMissingKeyHandler: (key) => {
    if (process.env.NODE_ENV === 'development') {
      throw new Error(`Missing Key: ${key}`)
    }

    return key
  },
})

i18next.languages = ['th', 'en']

export default i18next
